import { render, staticRenderFns } from "./Homeworks.vue?vue&type=template&id=0ffece96&"
import script from "./Homeworks.vue?vue&type=script&lang=js&"
export * from "./Homeworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports